import styled from "styled-components";
import {
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	MOBILE_L_BP,
	DESKTOP_M_BP,
	TABLET_M_BP,
	MOBILE_LM_BP,
	MOBILE_ML_BP,
	MOBILE_SM_BP,
	MOBILE_M_BP,
	COLOR_DARK_GREEN_BUTTON,
} from "@website-builder/utilities-index";

export const SliderWrapper = styled.div`
	padding: 84px 65px 115px 65px;
	.heading {
		font-size: 28px;
		font-weight: ${FONT_WT_MEDIUM};
		color: ${COLOR_TEXT_PRIMARY_B2C};
		float: right;
		width: 60%;
	}
	.content {
		float: right;
		width: 60%;
		font-size: 16px;
		font-weight: ${FONT_WT_LIGHT};
		line-height: 1.69;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		font-style: italic;
		margin-top: -28%;
		padding-right: 150px;
	}
	.userName {
		font-size: 20px;
		font-weight: ${FONT_WT_MEDIUM};
		line-height: 1.35;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		padding-top: 39px;
		float: right;
		width: 60%;
		margin-top: -16%;
	}
	.role {
		font-size: 16px;
		font-weight: ${FONT_WT_LIGHT};
		line-height: 1.69;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		float: right;
		width: 60%;
		margin-top: -11%;
	}
	.image {
		width: 30%;
	}
	.slick-slide img {
		display: inherit;
	}
	.slick-dots {
		width: 30%;
		bottom: -40px;
	}
	.slick-dots li {
		margin: 0px;
	}
	.slick-dots li.slick-active button:before {
		color: ${COLOR_DARK_GREEN_BUTTON};
	}
	.slick-dots li button:before {
		font-size: 15px;
		color: ${COLOR_DARK_GREEN_BUTTON};
	}
	.slick-next {
		right: 10px !important;
	}

	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		.content {
			padding-right: 0px !important;
		}
		.userName {
			margin-top: -14% !important;
		}
		.role {
			margin-top: -8% !important;
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 84px 30px 115px 40px;
		.content {
			width: 50%;
			margin-top: -40%;
		}
		.userName {
			width: 50%;
			margin-top: -20% !important;
		}
		.role {
			width: 50%;
			margin-top: -13% !important;
		}
		.heading {
			width: 50%;
		}
		.image {
			width: 45%;
		}
		.slick-dots {
			width: 45%;
		}
	}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		padding: 80px 20px 100px 20px;
		.content {
			margin-top: -45%;
		}
		.userName {
			margin-top: -16% !important;
		}
		.role {
			margin-top: -8% !important;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP - 1}px) {
		padding: 84px 20px 50px 20px;
		.heading {
			font-size: 24px;
			padding-bottom: 15px;
			line-height: 1.17;
			width: 100%;
			text-align: center;
			float: none;
		}
		.image {
			width: 60%;
			margin: auto;
			display: block !important;
		}
		.content {
			padding: 30px 20px 15px 20px;
			width: 100%;
			margin-top: 30px;
			float: none;
		}
		.userName {
			padding: 10px 20px 0px 20px;
			float: none;
			text-align: center;
			margin-top: 0% !important;
			width: 100%;
		}
		.role {
			padding: 5px 20px 0px 20px;
			float: none;
			text-align: center;
			margin-top: 0% !important;
			width: 100%;
		}
		.slick-dots {
			width: 100%;
		}
		.slick-dots li {
			margin: 0px;
		}
		.slick-dots li.slick-active button:before {
			color: ${COLOR_DARK_GREEN_BUTTON};
		}
		.slick-dots li button:before {
			font-size: 15px;
			color: ${COLOR_DARK_GREEN_BUTTON};
		}
	}

	@media only screen and (max-width: ${MOBILE_LM_BP}px) {
		.slick-dots {
			bottom: 345px;
			position: unset;
		}
	}

	@media only screen and (max-width: ${MOBILE_ML_BP}px) {
		.slick-dots {
			bottom: 370px;
			position: unset;
		}
	}

	@media only screen and (max-width: ${MOBILE_M_BP}px) {
		.slick-dots {
			bottom: 400px;
		}
	}

	@media only screen and (max-width: ${MOBILE_SM_BP}px) {
		.slick-dots {
			bottom: 420px;
		}
	}
`;
